import { RomaniaMaxPriceGroupItemStatusSerializable } from 'com.cogvio.pricemonitor.api';
import GeneralProduct from '~/Api/Product/Product';
import { ReferencePrice } from '~/Api/User/ProductGroup/RoMaxPrice/ReferencePrice';

export class Product {
	packageSizeForCalculation: number | null;

	packageSizeForSingleUnit: number | null;

	product: GeneralProduct;

	referenceDataSource: boolean;

	referencePrices: ReferencePrice[];

	selectable: boolean;

	selected: boolean;

	singleUnitPackageSize: boolean;

	groupItemStatus: RomaniaMaxPriceGroupItemStatusSerializable;

	constructor(
		packageSizeForCalculation: number | null,
		packageSizeForSingleUnit: number | null,
		product: GeneralProduct,
		referenceDataSource: boolean,
		referencePrices: ReferencePrice[],
		selectable: boolean,
		selected: boolean,
		singleUnitPackageSize: boolean,
		groupItemStatus: RomaniaMaxPriceGroupItemStatusSerializable
	) {
		this.packageSizeForCalculation = packageSizeForCalculation;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
		this.product = product;
		this.referenceDataSource = referenceDataSource;
		this.referencePrices = referencePrices;
		this.selectable = selectable;
		this.selected = selected;
		this.singleUnitPackageSize = singleUnitPackageSize;
		this.groupItemStatus = groupItemStatus;
	}

	findSelectedReferencePrice(): ReferencePrice | null {
		return this.referencePrices.find((price) => price.calculatedPrice.selected) ?? null;
	}
}
